import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSelectComponent } from '@progress/kendo-angular-upload';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { FinanceComponent } from './finance.component';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { CoreModule } from '../../core/core.module';
import { FeaturesModule } from '../../features/features.module';
import {
  EditorBoldButtonDirective,
  EditorComponent,
  EditorFontFamilyComponent,
  EditorFontSizeComponent,
  EditorItalicButtonDirective,
  EditorUnderlineButtonDirective,
  EditorViewSourceButtonDirective,
} from '@progress/kendo-angular-editor';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceListComponent } from './invoices/invoice-list/invoice-list.component';
import { EditInvoicePositionDialogComponent } from './invoices/dialogs/edit-invoice-position-dialog/edit-invoice-position-dialog.component';
import { InvoicePreviewComponent } from './invoices/shared/invoice-preview/invoice-preview.component';
import { InvoiceViewerComponent } from './invoices/shared/invoice-viewer/invoice-viewer.component';
import { InvoicePageFooterComponent } from './invoices/shared/invoice-page-footer/invoice-page-footer.component';
import { AfterValueChangedDirective } from '../../core/directives/after-value-changed.directive';
import { CreateInvoiceDialogComponent } from './invoices/dialogs/create-invoice-dialog/create-invoice-dialog.component';
import { InvoiceCreateEditComponent } from './invoices/invoice-creation-editing/invoice-create-edit.component';
import { InvoicePositionHandlerService } from './invoices/invoice-creation-editing/invoice-position-handler.service';
import { InvoiceStateService } from './invoices/invoice-creation-editing/state-and-data-handling/invoice-state.service';
import { CreateInvoiceDialogService } from './invoices/dialogs/create-invoice-dialog/create-invoice-dialog.service';
import { OperatingCostsDialogComponent } from './operating-costs/dialog/operating-costs-dialog/operating-costs-dialog.component';
import { OperatingCostsComponent } from './operating-costs/operating-costs.component';

@NgModule({
  declarations: [
    FinanceComponent,
    InvoicesComponent,
    InvoicePreviewComponent,
    InvoiceViewerComponent,
    InvoiceListComponent,
    InvoiceCreateEditComponent,
    InvoicePageFooterComponent,
    EditInvoicePositionDialogComponent,
    CreateInvoiceDialogComponent,
    OperatingCostsComponent,
    OperatingCostsDialogComponent,
  ],
  providers: [InvoicePositionHandlerService, InvoiceStateService, CreateInvoiceDialogService],
  imports: [
    CommonModule,
    RouterOutlet,
    SharedModule,
    CoreModule,
    FeaturesModule,
    EditorBoldButtonDirective,
    EditorComponent,
    EditorFontFamilyComponent,
    EditorFontSizeComponent,
    EditorItalicButtonDirective,
    EditorUnderlineButtonDirective,
    EditorViewSourceButtonDirective,
    AfterValueChangedDirective,
    AdminLayoutModule,
    FileSelectComponent,
  ],
})
export class FinanceModule {}
